export default "https://cdn.questicon.mathletics.com/assets/images/Correct-7dc62e04fae16a9c152a2a7d21dcfeab.svg";